import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/auctions";
import type { GetAuctionBetsQueryResponse, GetAuctionBetsPathParams, GetAuctionBets400, GetAuctionBets404 } from "../types/GetAuctionBets";

export const getAuctionBetsQueryKey = (auctionId: GetAuctionBetsPathParams["auctionId"]) =>     [{url:`/auctions/${auctionId}/bets`,params:{auctionId:auctionId}}] as const;
      export function getAuctionBetsQueryOptions <TData = GetAuctionBetsQueryResponse, TError = GetAuctionBets400 | GetAuctionBets404>(auctionId: GetAuctionBetsPathParams["auctionId"], options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getAuctionBetsQueryKey(auctionId, );

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/auctions/${auctionId}/bets`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /auctions/:auctionId/bets
 */

export function useGetAuctionBets <TData = GetAuctionBetsQueryResponse, TError = GetAuctionBets400 | GetAuctionBets404>(auctionId: GetAuctionBetsPathParams["auctionId"], options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAuctionBetsQueryKey(auctionId, );

  const query = useQuery<TData, TError>({
    ...getAuctionBetsQueryOptions<TData, TError>(auctionId, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
